import { useMutation, useQuery } from "@tanstack/react-query";
import { get, post, put } from "../../api/client";
import { STUDENTS_LIST_KEY } from "../students/useStudentsLists.hooks";
interface RegisterParentsBody {
  firstName: string;
  middleName: String;
  lastName: string;
  gender: string;
  email: string;
  password: string;
  mobile: string;
  parentalRelationship: string;
  address: string;
}

export const PARENTS_KEYS = {
  PARENTS: "PARENTS",
};

export const useParentRegistration = () => {
  const { isLoading, mutate } = useMutation((body: RegisterParentsBody) => {
    const payload = {
      first_name: body.firstName,
      middle_name: body.middleName,
      last_name: body.lastName,
      gender: body.gender,
      email: body.email,
      password: body.password,
      mobile: body.mobile,
      parental_relationship: body.parentalRelationship,
      address: body.address,
    };
    return post({
      url: "api/v1/parents/register-parents-admin",
      body: payload,
    });
  });

  return { isLoading, registerParents: mutate };
};
export const useGetParentById = ({ parentId }: { parentId: number }) =>
  useQuery([parentId, PARENTS_KEYS.PARENTS], () =>
    get({ url: `api/v1/parents/${parentId}` })
  );

export const useUpdateParent = ({ parentId }: { parentId: number }) =>
  useMutation((body: RegisterParentsBody) => {
    const payload = {
      first_name: body.firstName,
      middle_name: body.middleName,
      last_name: body.lastName,
      gender: body.gender,
      email: body.email,
      password: body.password,
      mobile: body.mobile,
      parental_relationship: body.parentalRelationship,
      address: body.address,
    };
    return put({
      url: `api/v1/parents/update-parents-admin/${parentId}`,
      body: payload,
    });
  });

export const useGetStudentsOfParent = ({ parentId }: { parentId: number }) =>
  useQuery([STUDENTS_LIST_KEY.STUDENTS_LIST, parentId], () =>
    get({ url: `api/v1/parents/students/${parentId}`, includeToken: true })
  );

export const useGetMyChild = () =>
  useQuery([STUDENTS_LIST_KEY.STUDENTS_LIST], () =>
    get({ url: `api/v1/parents/my-child` })
  );

export const useGetOverviewData = () =>
  useQuery([], () => get({ url: `api/v1/parents/overview` }));
